import { estimatePlan, type PlanEstimate } from "@roxpacer/core";
import { useMemo } from "react";
import { useActivePlan } from "../store";

export function useEstimate(): PlanEstimate {
  const plan = useActivePlan();
  return useMemo(() => estimatePlan(plan), [plan]);
}
